"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  color: ", ";\n  font-size: 14px;\n  line-height: 21px;\n  border-bottom: 2px solid ", ";\n  width: 149px;\n  padding-bottom: 5px;\n  transition: 0.1s all;\n  cursor: pointer;\n  &.active {\n    font-size: 18px;\n    border-bottom: 2px solid ", ";\n  }\n  & + * {\n    margin-left: 10px;\n  }\n"])), _variables.FontFamily.Raleway_500, _variables.GlobalColors.s5, _variables.GlobalColors.s3, _variables.GlobalColors.magenta_s2);

exports.Container = Container;